import { Injectable, inject } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { DialogResult } from '@shared/features/dialog/data-access/result.types';
import { ConfirmationConfig } from '@shared/features/dialog/features/confirmation-dialog/data-access/confirmation.types';
import { ConfirmationDialogComponent } from '@shared/features/dialog/features/confirmation-dialog/features/dialog.component';

@Injectable({ providedIn: 'root' })
export class ConfirmationDialogService {
  private readonly matDialog = inject(MatDialog);
  private readonly defaultConfig: Omit<ConfirmationConfig, 'title'> = {
    icon: {
      show: true,
      name: 'tabler-plus',
      color: 'error',
    },
    actions: {
      confirm: {
        show: true,
        label: 'Potwierdź',
        color: 'error',
      },
      cancel: {
        show: true,
        label: 'Anuluj',
      },
    },
    dismissible: true,
  };

  open(config: ConfirmationConfig): MatDialogRef<ConfirmationDialogComponent, DialogResult<void>> {
    const userConfig: ConfirmationConfig = {
      ...this.defaultConfig,
      ...config,
      icon: {
        ...this.defaultConfig.icon,
        ...config.icon,
      },
      actions: {
        confirm: {
          ...this.defaultConfig.actions?.confirm,
          ...config.actions?.confirm,
        },
        cancel: {
          ...this.defaultConfig.actions?.cancel,
          ...config.actions?.cancel,
        },
      },
    };

    return this.matDialog.open(ConfirmationDialogComponent, {
      disableClose: !userConfig.dismissible,
      data: userConfig,
    });
  }
}
